// Định dạng dùng chung cho toàn bộ admin (VND, ngày giờ VN)

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const formatNumber = (value) => new Intl.NumberFormat('vi-VN').format(Math.floor(toNumber(value)));

export const formatCurrency = (value) => `${formatNumber(value)} ₫`;

// Rút gọn cho ô KPI trên mobile: 1.250.000 -> 1,25 tr; 2.300.000.000 -> 2,3 tỷ
export const formatCompactCurrency = (value) => {
  const n = toNumber(value);
  const abs = Math.abs(n);
  const fmt = (v, digits) => new Intl.NumberFormat('vi-VN', { maximumFractionDigits: digits }).format(v);
  if (abs >= 1e9) return `${fmt(n / 1e9, 2)} tỷ`;
  if (abs >= 1e6) return `${fmt(n / 1e6, 2)} tr`;
  if (abs >= 1e4) return `${fmt(n / 1e3, 0)}k`;
  return `${formatNumber(n)} ₫`;
};

export const formatPercent = (ratio, digits = 1) =>
  `${new Intl.NumberFormat('vi-VN', { maximumFractionDigits: digits }).format(toNumber(ratio) * 100)}%`;

const toDate = (value) => {
  if (value === null || value === undefined || value === '' || value === 0) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Unix timestamp (giây) -> Date
export const fromUnix = (seconds) => (toNumber(seconds) > 0 ? new Date(toNumber(seconds) * 1000) : null);

export const formatDate = (value) => {
  const d = toDate(value);
  return d ? d.toLocaleDateString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' }) : '—';
};

export const formatDateTime = (value) => {
  const d = toDate(value);
  return d
    ? d.toLocaleString('vi-VN', {
        timeZone: 'Asia/Ho_Chi_Minh',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    : '—';
};

// "5 phút trước", "3 giờ trước", "2 ngày trước"
export const formatRelative = (value) => {
  const d = toDate(value);
  if (!d) return '—';
  const diff = Date.now() - d.getTime();
  const abs = Math.abs(diff);
  const suffix = diff >= 0 ? 'trước' : 'nữa';
  const minutes = Math.round(abs / 60000);
  if (minutes < 1) return 'vừa xong';
  if (minutes < 60) return `${minutes} phút ${suffix}`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} giờ ${suffix}`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} ngày ${suffix}`;
  return formatDate(d);
};

export const daysSince = (value) => {
  const d = toDate(value);
  return d ? Math.floor((Date.now() - d.getTime()) / 86400000) : null;
};

// YYYY-MM-DD theo giờ VN (cho input type=date)
export const todayYmd = () => new Date(Date.now() + 7 * 3600000).toISOString().slice(0, 10);

export const sumItemCommission = (items) =>
  (items || []).reduce((sum, item) => sum + toNumber(item.itemTotalCommission), 0);
